import { TrackingService } from '../../../common/tracking/trackingService';
import { trackClickEvent } from '../../../modules/GlintsTracking/tracking';

export function trackVIPExpiringNavbarBannerImpression() {
  TrackingService.logEvent('vip_expiring_navbar_banner_impression');
}

export function trackVIPExpiringNavbarBannerCTAClicked() {
  TrackingService.logEvent('vip_expiring_navbar_banner_cta_clicked');
  trackClickEvent({
    elementName: 'vip_expiring_navbar_banner_cta',
  });
}
